
























































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CSelect from '@/components/base/select/CSelect.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CTable from '@/components/base/table/CTable.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import AIEnum from '@/enums/AIEnum';

@Component({
    components: {CCheckbox, CNumberField, CTable, CDatepicker, CSelect},
})
export default class WarehousePlywoodAuditEditDialogContent extends Vue {
    @Prop() value!: any;
    @Prop() vocabulary!: Map<string, Map<number, string>> | null;

    private data = this.value;
    private aiEnum = AIEnum;

    get headers() {
        let warehousePiece =
            this.data?.IdWarehousePlywood === null
                ? [
                      {
                          value: 'IdWarehousePlywood',
                          text: this.$t('Catalogues.Warehouses.WarehousePlywood.NameSingle'),
                          sortable: true,
                          sort: this.getSelectSort(this.$api.catalogues.warehousePlywood),
                      },
                  ]
                : [];
        return [
            ...warehousePiece,
            {
                value: 'IdPlywoodGrade',
                text: this.$t('Catalogues.Plywoods.PlywoodGrade.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.plywoodGrade),
            },
            {
                value: 'IdPlywoodSize',
                text: this.$t('Catalogues.Plywoods.PlywoodSize.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.plywoodSize),
            },
            {
                value: 'IdPlywoodThickness',
                text: this.$t('Catalogues.Plywoods.PlywoodThickness.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.plywoodThickness),
            },
            {
                value: 'IdPlywoodSpecie',
                text: this.$t('Catalogues.Plywoods.PlywoodSpecie.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.plywoodSpecie),
            },
            {
                value: 'IdPlywoodSurface',
                text: this.$t('Catalogues.Plywoods.PlywoodSurface.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.plywoodSurface),
            },
            {
                value: 'IdPlywoodWaterResistance',
                text: this.$t('Catalogues.Plywoods.PlywoodWaterResistance.NameSingle'),
                sortable: true,
                sort: this.getSelectSort(this.$api.catalogues.plywoodWaterResistance),
            },
            {
                value: 'IsForTenonGroove',
                text: this.$t('Documents.Plan.TenonGroove'),
                sortable: true,
            },
            {
                value: 'CurrentVolume',
                text: this.$t('Common.CurrentVolume'),
                sortable: true,
            },
            {
                value: 'AuditVolume',
                text: this.$t('Common.ActualVolume'),
                sortable: true,
            },
            {
                value: 'VolumeMeasureUnit',
                text: this.$t('Common.VolumeUnit'),
                sortable: true,
                sort: this.getSelectSort(this.$api.measureUnit),
            },
        ];
    }

    get tableAddData() {
        return {
            IdWarehousePlywood: this.data.IdWarehousePlywood,
            CurrentVolume: 0,
            AuditVolume: 0,
            VolumeMeasureUnit: null,
            IdPlywoodGrade: null,
            IdPlywoodSize: null,
            IdPlywoodThickness: null,
            IdPlywoodSpecie: null,
            IdPlywoodSurface: null,
            IdPlywoodWaterResistance: null,
            IsForTenonGroove: false,
        };
    }

    @Watch('data', {deep: true})
    onDataChange(value: any) {
        this.$emit('input', value);
    }

    getSelectSort(mapKey: string) {
        return (a: number, b: number) => {
            if (this.vocabulary) {
                const A = (this.vocabulary as any).get(mapKey).get(a).order,
                    B = (this.vocabulary as any).get(mapKey).get(b).order;
                return A - B;
            } else return 0;
        };
    }
}
